<template>
  <div class="registerNow">
    <div class="registerNow-info">
      <h3>注册</h3>
      <p>请填写企业资料，进行注册申请</p>
      <div class="register-form">
        <ansoForm
          ref="detailForm"
          :form="form"
          labelPosition="top"
          :formList="formList"
          class="detailForm"
        ></ansoForm>
        <el-button class="submit-btn" type="primary" size="small" :loading="loading" @click="submit"
          >提交申请</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getNoiseRegister } from '@/api/Login'
import { SUCCESS_CODE } from 'comm/src/config'
import ansoForm from 'comm/src/components-comm/anso-form'
import { Snowflake } from 'comm/src/utils/normal/fun.js'
export default {
  name: 'registerNow',
  components: { ansoForm },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.confirmPwd !== '') {
          this.$refs.detailForm.$refs.ansoForm.validateField('confirmPwd')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.pwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {},
      formList: [
        {
          field: 'tenantName',
          label: '企业名称 ',
          span: 24
        },
        {
          field: 'tenantCode',
          label: '企业编号 ',
          span: 24,
          maxlength: 16,
          rules: [
            { required: true, message: '请输入企业编号', trigger: 'blur' },
            {
              pattern: /^[0-9a-zA-Z]*$/,
              message: '请输入数字或者字母',
              trigger: 'blur'
            }
          ]
        },
        {
          field: 'tenantAccount',
          label: '管理员账号 ',
          span: 24
        },
        {
          field: 'pwd',
          label: '密码 ',
          span: 24,
          type: 'password',
          rules: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ]
        },
        {
          field: 'confirmPwd',
          label: '确认密码 ',
          span: 24,
          type: 'password',
          rules: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
        {
          field: 'mobile',
          label: '手机号码 ',
          span: 24,
          rules: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: '请输入正确的手机号码',
              trigger: 'blur'
            }
          ]
        }
      ]
    }
  },
  watch: {},
  created() {},
  mounted() {
    // let rand = new Snowflake(1n, 1n, 0n)
    // this.$set(this.form, 'tenantCode', rand.nextId() + '')
  },
  methods: {
    submit() {
      this.$refs.detailForm.submitForm(async valid => {
        if (valid) {
          let params = {
            ...this.form
          }
          delete params.confirmPwd
          this.loading = true
          const { code, message } = await getNoiseRegister(params)
          this.loading = false
          if (code === SUCCESS_CODE) {
            this.$confirm('注册成功！请使用管理员账号和密码进行登录', '提示', {
              confirmButtonText: '立即登录',
              cancelButtonText: '取消',
              type: 'info'
            })
              .then(async () => {
                this.$router.push({
                  path: '/login'
                })
              })
              .catch(() => {})
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.registerNow {
  width: 100%;
  height: 100%;
  padding-top: 40px;
  box-sizing: border-box;
  background: #f2f3f5;
  .registerNow-info {
    background: #fff;
    width: 80%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px 20%;
    border-radius: 2px;
    h3 {
      font-size: 20px;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 8px;
      margin-top: 0;
    }
    p {
      color: #548ff5;
      font-size: 14px;
      margin-bottom: 24px;
      line-height: 1;
      margin-top: 0;
    }
  }
  .submit-btn {
    width: 100%;
    margin-top: 24px;
  }
}
</style>
